import React, { Component } from 'react'
import { Button, Form, Grid, Header, Image, Input, Message, Segment } from 'semantic-ui-react'
import { log } from '../../Utilities/Utils'
import { firebaseAuth, logDashboardAction, logDashboardLogin } from '../../config/constants.js'
import * as UiConsts from '../../config/UiConstants'
import { checkAdminEmail } from './newDashboard/algoliaDashboard/AlgoliaMiscUtils';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export default class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: ''
        }
    }

    componentDidMount() {
        //1. GET MAIN CARD OBJECTS FROM ALGOLIA
        //getPrintValues("dailyExpenses", this.setDailyExpenseOptions);

        console.log(`device: ${window.navigator.userAgent}`);

        logDashboardLogin("unknownAdmin@printboda.com", `${window.navigator.userAgent}`, "loaded_loginForm", "LoginForm");

    }

    handleChange = (e) => {
        // log("hx1 >>>>: handleChange clicked");
        // log("hx33 e.target.type:" + e.target.type);
        // log("hx32 e.target.name:" + e.target.name);
        // log("hx34 e.target.value:" + e.target.value);

        let newState = {};
        newState[e.target.name] = e.target.value;
        this.setState(newState);

    }

    handleSubmit = (e) => {
        e.preventDefault();
        // console.log("lgx1 ++++++++: handleSubmit");
        // console.log(this.state.email);
        // console.log(this.state.password);

        this.loginUser(this.state.email, this.state.password)

        //this.props.loginMethod(this.state.email,this.state.password);
        //  log("lgx33 e.target.type:" + e.target.type);
        // log("lgx32 e.target.name:" + e.target.name);
        // login(this.email.value, this.pw.value)
        //     .catch((error) =>{
        //         this.setState(setErrorMessage('Invalid Username / Password'))
        //     })
    }

    loginUser = (email, password) => {
        log("px19 ++++++++:loginUser");
        log("px20 email:" + email);


        this.setState({ loading: true });

        firebaseAuth().signInWithEmailAndPassword(email, password)
            //.then(tempFunc(user.uid))
            .then((user) => {
                console.log('logged in:', user.email);

               // logDashboardAction(user.email + " login part 1", user.email, null,"loginForm");

                //logDashboardLogin(user.email , `${window.navigator.userAgent}`, "loginForm_part_1", "LoginForm");

                logDashboardLogin(user.email, `${window.navigator.userAgent}`, "logged_in", "LoginForm");
                

                if (user.email) {
                    checkAdminEmail(user.email, this.setAdminResult);
                    this.setState({
                        // authed: true,
                        // admin: true,
                        // loading: false,
                        user: user,
                        // uid: user.uid,
                        // loading: false
                    })
                }


            })
            .catch((error) => {
                // Handle Errors here.
                var errorCode = error.code;
                var errorMessage = error.message;
                if (errorCode === 'auth/wrong-password') {
                    alert('Wrong password.');
                } else {
                    alert(errorMessage);
                }
                console.log(error);

                //logDashboardAction(email + " FAILED login "+`device: ${window.navigator.userAgent}`, email, null, "loginForm");

                logDashboardLogin("unknownAdmin@printboda.com", `${window.navigator.userAgent}`, email+"_failed_login", "LoginForm");

                this.setState({ loading: false });
            });
    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ mdbrx14 setAdminResult");
        // console.log("mdbrx15 returnObject:" + JSON.stringify(returnObject, null, 3));

        if (returnObject.algoliaUser && returnObject.algoliaUser.isAdmin) {
           // console.log("mdbrx16 returnObject.algoliaUser && returnObject.algoliaUser.isAdmin:");

            logDashboardAction(returnObject.algoliaUser.key + " logged in "+`device: ${window.navigator.userAgent}`, returnObject.algoliaUser.key, null, "loginForm");

            this.setState({
                authed: true,
                admin: true,
                algoliaUser: returnObject.algoliaUser,
                loading: false
            })

            //logDashboardAction(logAction, adminEmail, order_num){

            history.push("/dashboard");

        } else {
            this.setState({
                authed: false,
                admin: false,
                algoliaUser: '',
                loading: false
            })
            alert("Error occured...");
        }

    }

    componentWillMount() {
        document.body.classList.add('login')
    }

    componentWillUnmount() {
        document.body.classList.remove('login')
    }

    render() {
        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <Grid
                textAlign='center'
                style={{ height: '100%' }}
                verticalAlign='middle'
            >
                <Grid.Column style={{ maxWidth: 450 }}>
                    <Header as='h2' color='teal' textAlign='center'>
                        <Image src='/logo.png' />
                        {' '}Log-in to your account
                    </Header>
                    <Form size='large' onSubmit={this.handleSubmit}>
                        <Segment stacked>
                            <Form.Input
                                fluid
                                icon='user'
                                iconPosition='left'
                                placeholder='E-mail address'
                                name="email"
                                onChange={this.handleChange}
                            />
                            {/* <input  ref={(email) => this.email = email} placeholder="Email"/> */}
                            <Form.Input
                                fluid
                                icon='lock'
                                iconPosition='left'
                                placeholder='Password'
                                type='password'
                                name="password"
                                onChange={this.handleChange}
                            />
                            {/* <input type="password" placeholder="Password" ref={(pw) => this.pw = pw} /> */}

                            <Button color='teal' fluid size='large'>Login</Button>
                        </Segment>
                    </Form>
                </Grid.Column>
            </Grid>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/LoginForm.js